import { ImageAnalysisResult, UADAnalysisResult } from '@aloft/toolkit-shared';
import { Flex, Modal, Typography } from '@aloft/toolkit-sui';

import { CraftsmanResults } from './CraftsmanResults.tsx';
import { BulkCompResult } from './bulkAnalysisTypes.ts';
import { ImageCarousel } from './ImageCarousel.tsx';
import { RawTextAccordion } from './RawTextAccordion.tsx';
import { TimingBar } from './TimingBar.tsx';
import { UADResults } from './UADResults.tsx';

type Props = {
  result: BulkCompResult | null;
  onClose: () => void;
};

export const BulkCompDetailModal = ({ result, onClose }: Props) => {
  const isOpen = result != null && result.status === 'success' && result.fullResult != null;

  if (!isOpen || result == null || result.fullResult == null) {
    return <Modal title="" isOpen={false} onClose={onClose} />;
  }

  const { fullResult, comp } = result;
  const title = comp.address ?? comp.compID.slice(0, 8);
  const debug = fullResult._debug;
  const timing = debug?.timing;
  const tokenUsage = debug?.tokenUsage;
  // Prefer the sampled subset actually sent to Gemini; fall back to all comp URLs.
  const imageURLs = debug?.imageURLs ?? comp.imageURLs;

  return (
    <Modal title={title} isOpen onClose={onClose} size="4xl">
      <Flex flexDirection="column" gap="20px">
        {timing != null && <TimingBar timing={timing} tokenUsage={tokenUsage} />}

        {debug?.promptBlockReason != null && (
          <Typography variant="body2" color="textWarning">
            Prompt blocked by Gemini — reason: <strong>{debug.promptBlockReason}</strong>
          </Typography>
        )}

        {fullResult.mode === 'craftsmanQuality' && (
          <CraftsmanResults data={fullResult as ImageAnalysisResult} />
        )}
        {fullResult.mode === 'uadRatings' && (
          <UADResults data={fullResult as UADAnalysisResult} />
        )}

        {imageURLs.length > 0 && <ImageCarousel urls={imageURLs} />}

        {debug?.rawText != null && (
          <RawTextAccordion rawText={debug.rawText} thoughtsText={debug.thoughtsText} />
        )}
      </Flex>
    </Modal>
  );
};
